import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ElementNameEditor } from './ElementNameEditor';
import { ZIndexDisplay } from './ZIndexDisplay';
/**
 * Блок с информацией об элементе: z-index и имя.
 */
export const ElementInfoBlock = ({ selectedElements, onUpdateElementName, }) => {
    const element = selectedElements.length === 1 ? selectedElements[0] : null;
    const multipleElements = selectedElements.length > 1;
    return (_jsxs("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            padding: 0,
            margin: 'auto',
        }, children: [_jsx(ZIndexDisplay, { selectedElements: selectedElements }), _jsx(ElementNameEditor, { element: element, multipleElements: multipleElements, onUpdateName: onUpdateElementName })] }));
};
